import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { EnumConselho } from 'app/model/enumConselho';
import {ParticipacaoConselhoRequestDto} from "../../components/recadastramento-aba13/ParticipacaoConselhoRequest.dto";
import {ParticipacaoConselhoDto} from "../../components/recadastramento-aba13/ParticipacaoConselho.dto";
import {AuxilioSaudeFormDto} from "../../components/recadastramento-aba10/AuxilioSaudeForm.dto";
import {ArquivoBlobDTO} from "../../model/arquivoBlob.dto";

@Injectable()
export class ConselhoAba13Service extends GenericService {
    private pathParametrosIniciais = environment.url + 'api/v1/conselho';
    private path = environment.url + 'api/v1';

    constructor(http: HttpClient) {
        super(http);
    }

    getFormaParticipacao(): Observable<EnumConselho[]> {
        return this.http.get<EnumConselho[]>(this.pathParametrosIniciais+"/forma-participacao");
    }

    getOrigemParticipacao(): Observable<EnumConselho[]> {
      return this.http.get<EnumConselho[]>(this.pathParametrosIniciais+"/origem");
    }

    getTipoParticipacao(): Observable<EnumConselho[]> {
      return this.http.get<EnumConselho[]>(this.pathParametrosIniciais+"/tipo-participacao");
    }

    getParticipacaoConselho(): Observable<ParticipacaoConselhoDto> {
        return this.http.get<ParticipacaoConselhoDto>(this.path+"/participacao-conselho");
        /*return new Observable<ParticipacaoConselhoDto>( (observer) => {
            let participacao = new ParticipacaoConselhoDto();
            participacao.idFormaParticipacao = 1;
            participacao.dataMandatoFim = '01/06/2023';
            participacao.dataMandatoInicio = '01/01/2023';
            participacao.idTipoParticipacao = 1;
            participacao.idOrigem = 1;
            participacao.funcao = 'adfdsfsdaf';
            participacao.leiNormaAtoCriacao = 'cccc';
            participacao.nomeConselhoAssemelhado = 'bbbb';
            participacao.nomeOrgaoVinculado = 'aaaaa';
            participacao.isAnexo = true;
            observer.next(participacao);
        })*/
    }

    salvarParticipacaoConselho(participacao: ParticipacaoConselhoRequestDto): Observable<any> {
        return this.http.put<any>(this.path+"/participacao-conselho", participacao);
    }

    uploadComprovante(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);

        return this.patchMethodFile(this.path + '/upload_comprovante/participacao-conselho', formData);
    }

    visualizarComprovante(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.path + '/visualizar_comprovante/participacao-conselho', options);
    }
}
